import { defineMessages } from 'react-intl';

const messages = defineMessages({
    sorryNoResultsFound: {
        id:'sorryNoResultsFound',
        defaultMessage: 'Sorry, no results found.',
        description: 'Error message when search returns no results.',
    },
    noResultsFoundSuggestion: {
        id:'noResultsFoundSuggestion',
        defaultMessage: 'Try using different keywords.',
        description: 'Suggestion to users when search results come empty.',
    },
});

export default messages;
